import dayjs from 'dayjs';
import { isoDayOfWeekFromJsDay } from 'shared/checkin-days';

/**
 * The standup days of the Monday-to-Sunday week holding `localDate`, as
 * YYYY-MM-DD strings, limited to the course's standup window. The lesson
 * page counts a student's week against these.
 */
export function weekStandupDays(opts: {
  localDate: string;
  days: number[];
  startDate?: string;
  endDate?: string;
}): string[] {
  const date = dayjs(opts.localDate);
  const monday = date.subtract(isoDayOfWeekFromJsDay(date.day()) - 1, 'day');
  const result: string[] = [];
  for (let i = 0; i < 7; i += 1) {
    const day = monday.add(i, 'day');
    const iso = day.format('YYYY-MM-DD');
    if (!opts.days.includes(isoDayOfWeekFromJsDay(day.day()))) {
      continue;
    }
    if ((opts.startDate && iso < opts.startDate) || (opts.endDate && iso > opts.endDate)) {
      continue;
    }
    result.push(iso);
  }
  return result;
}

/**
 * Whether a lesson belongs to the standup weeks: its module opens inside the
 * course's standup window. The window is widened back to the Sunday before
 * the week standups start, so a week's module released a day or two before
 * the first standup (Monday modules, Tuesday standups; Sunday-night releases)
 * still counts. A lesson with no release date, or a course with no window,
 * counts as inside.
 */
export function isStandupLesson(opts: {
  moduleDate?: string;
  startDate?: string;
  endDate?: string;
}): boolean {
  if (!opts.moduleDate) {
    return true;
  }
  if (opts.startDate) {
    const start = dayjs(opts.startDate);
    // dayjs counts Sunday as 0, so a Sunday start is its own bound.
    const sundayBefore = start.subtract(start.day(), 'day').format('YYYY-MM-DD');
    if (opts.moduleDate < sundayBefore) {
      return false;
    }
  }
  if (opts.endDate && opts.moduleDate > opts.endDate) {
    return false;
  }
  return true;
}
